var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-anchor",
    style: _vm.styles,
    attrs: {
      "id": _vm.$attrs._id
    }
  }, [_c('div', {
    staticClass: "tag-line",
    style: _vm.lineStyle
  }), _vm.tailPosition !== 'none' ? _c('div', {
    staticClass: "tag-dot"
  }) : _vm._e(), _c('div', {
    ref: "el",
    staticClass: "tag-ref",
    class: ["tag-ref--".concat(_vm.type)],
    style: _vm.labelStyle
  }, [_c('div', {
    staticClass: "tag-ref__label"
  }, [_vm._v(_vm._s(_vm.$attrs.referenceIndex))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }